// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://sepolia.basescan.org/address/0x6f7E694fe5250Ce638fFE95524760422E6e41997
export const POOL_ADDRESSES_PROVIDER = '0x6f7E694fe5250Ce638fFE95524760422E6e41997';

// IPool https://sepolia.basescan.org/address/0x423b16E67D9b7ea095Bc443F1Cb9621c54A3db1D
export const POOL = '0x423b16E67D9b7ea095Bc443F1Cb9621c54A3db1D';

// IPoolConfigurator https://sepolia.basescan.org/address/0xb5264423c271310dB16be084dA3e360d6c4A8b85
export const POOL_CONFIGURATOR = '0xb5264423c271310dB16be084dA3e360d6c4A8b85';

// IAaveOracle https://sepolia.basescan.org/address/0xfaec2d4b5971C9C18Ec25363C34B8a9A7658EBB6
export const ORACLE = '0xfaec2d4b5971C9C18Ec25363C34B8a9A7658EBB6';

// https://sepolia.basescan.org/address/0x6ec33534BE07d45cc4E02Fbd127F8ed2aE919a6b
export const ACL_ADMIN = '0x6ec33534BE07d45cc4E02Fbd127F8ed2aE919a6b';

// IACLManager https://sepolia.basescan.org/address/0x7C5Bd69e2842363139C2CA726baAd128B0B19976
export const ACL_MANAGER = '0x7C5Bd69e2842363139C2CA726baAd128B0B19976';

// IPoolDataProvider https://sepolia.basescan.org/address/0xCA4387fde255D7a0Ea27Abad1F8481e5069d3223
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xCA4387fde255D7a0Ea27Abad1F8481e5069d3223';

// https://sepolia.basescan.org/address/0xAc806981b236FEF6ca11Ce9Aa3487f97128fDC03
export const POOL_IMPL = '0xAc806981b236FEF6ca11Ce9Aa3487f97128fDC03';

// https://sepolia.basescan.org/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://sepolia.basescan.org/address/0x543f2b0C2085E74b9A1c3A2D0f35825D9D02237D
export const DEFAULT_INCENTIVES_CONTROLLER = '0x543f2b0C2085E74b9A1c3A2D0f35825D9D02237D';

// https://sepolia.basescan.org/address/0x635b4a9ec6c6B6b764347edc343CFf091FbAE0Ad
export const EMISSION_MANAGER = '0x635b4a9ec6c6B6b764347edc343CFf091FbAE0Ad';

// ICollector https://sepolia.basescan.org/address/0xA49b77212c4a6C689B78CfA448bb2cd254E87c07
export const COLLECTOR = '0xA49b77212c4a6C689B78CfA448bb2cd254E87c07';

// https://sepolia.basescan.org/address/0x1DfD57fA56C48C411aF3B344f88E7771a5bcA94c
export const DEFAULT_A_TOKEN_IMPL = '0x1DfD57fA56C48C411aF3B344f88E7771a5bcA94c';

// https://sepolia.basescan.org/address/0x53Ed39c879B67262472aECE040DA885F09fA6669
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x53Ed39c879B67262472aECE040DA885F09fA6669';

// https://sepolia.basescan.org/address/0x7e66C9c25E91200b8713d5E926b0e12496636dF5
export const CONFIG_ENGINE = '0x7e66C9c25E91200b8713d5E926b0e12496636dF5';

// https://sepolia.basescan.org/address/0xEC239206602f299b5d0A7dDfd7A9ed1F2ebeE020
export const L2_ENCODER = '0xEC239206602f299b5d0A7dDfd7A9ed1F2ebeE020';

// https://sepolia.basescan.org/address/0xDda880c5Cf474b68cc79f89fa2A2F8513015FF20
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xDda880c5Cf474b68cc79f89fa2A2F8513015FF20';

// https://sepolia.basescan.org/address/0xAc5Cc0A193C6FAc2616c7c5FACfd1C9DB909371C
export const UI_INCENTIVE_DATA_PROVIDER = '0xAc5Cc0A193C6FAc2616c7c5FACfd1C9DB909371C';

// https://sepolia.basescan.org/address/0x912D4A80f8cA3959eB49Ce38f060c46323D1e3A4
export const UI_POOL_DATA_PROVIDER = '0x912D4A80f8cA3959eB49Ce38f060c46323D1e3A4';

// https://sepolia.basescan.org/address/0x2a5208950631917efE7EbE969eC1be68EE46AB16
export const WALLET_BALANCE_PROVIDER = '0x2a5208950631917efE7EbE969eC1be68EE46AB16';

// https://sepolia.basescan.org/address/0x63bBa35193cB5E061E8F0318F8A1788EA34E5198
export const WETH_GATEWAY = '0x63bBa35193cB5E061E8F0318F8A1788EA34E5198';

export const CHAIN_ID = 84532;
export const ASSETS = {
  USDC: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x31DeecB1f03D68154fB7d86EA54F3276afDC33e3',
    A_TOKEN: '0x005E9Aea520839b897FC97cfBc39bbc58539Ee8B',
    V_TOKEN: '0x31cC4e1faA41C748e4aA4E2e7CA0E7C03B39092E',
    INTEREST_RATE_STRATEGY: '0x25286160e24a8567B24649AD230f581BC9DC1a66',
    ORACLE: '0xd30e2101a97dcbAeBCBC04F14C3f624E67A35165',
  },
  USDT: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x3cbFF758cB60163f5C59055f0e89cBc60699A143',
    A_TOKEN: '0x1f1258B4584E7227F0A1d8c6f6503Bc1eEE72734',
    V_TOKEN: '0x737c471a6eE5891C554B87127dE5bF95B5806374',
    INTEREST_RATE_STRATEGY: '0x25286160e24a8567B24649AD230f581BC9DC1a66',
    ORACLE: '0x3ec8593F930EA45ea58c968260e6e9FF53FC934f',
  },
  DAI: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0x9320CDD004557870e6066fEf0C88B46F9fCeA9e0',
    A_TOKEN: '0x5c941817F022fc61bB4587E7983fD7ed95B9117e',
    V_TOKEN: '0x5fba1aBb20B8F1C558992557Bc0d74C5Af9F04d7',
    INTEREST_RATE_STRATEGY: '0x25286160e24a8567B24649AD230f581BC9DC1a66',
    ORACLE: '0xD1092a65338d049DB68D7Be6bD89d17a0929945e',
  },
  WETH: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    A_TOKEN: '0xFBcD8add8F85BdfeDfF99E20D6fc4b215a9C96e3',
    V_TOKEN: '0x1a22c2261A23516D9A14bCAbC0B6522Eb98220fF',
    INTEREST_RATE_STRATEGY: '0x25286160e24a8567B24649AD230f581BC9DC1a66',
    ORACLE: '0x4aDC67696bA383F43DD60A9e78F2C97Fbbfc7cb1',
  },
  cbETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xc246553D4aff65E8091ed6072bE7Db6fb5318657',
    A_TOKEN: '0xeba135faBD9585Fd24879d95435F198AEb9D8a0c',
    V_TOKEN: '0x4B91a4D368a92C0aF8e5dB3Fb557ee75E391695E',
    INTEREST_RATE_STRATEGY: '0x25286160e24a8567B24649AD230f581BC9DC1a66',
    ORACLE: '0x3c65e28D357a37589e1C7C86044a9f44dDC17134',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'WETH,cbETH / WETH,cbETH',
    collateralBitmap: '24',
    collateralAssets: [
      '0x4200000000000000000000000000000000000006',
      '0xc246553D4aff65E8091ed6072bE7Db6fb5318657',
    ],
    borrowableBitmap: '24',
    borrowableAssets: [
      '0x4200000000000000000000000000000000000006',
      '0xc246553D4aff65E8091ed6072bE7Db6fb5318657',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10250,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
